import { render, staticRenderFns } from "./layer.vue?vue&type=template&id=259d5238&scoped=true&lang=pug&"
import script from "./layer.vue?vue&type=script&lang=js&"
export * from "./layer.vue?vue&type=script&lang=js&"
import style0 from "./layer.vue?vue&type=style&index=0&id=259d5238&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259d5238",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('259d5238', component.options)
    } else {
      api.reload('259d5238', component.options)
    }
    module.hot.accept("./layer.vue?vue&type=template&id=259d5238&scoped=true&lang=pug&", function () {
      api.rerender('259d5238', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layertree/component/label/layer.vue"
export default component.exports